import { Component, OnDestroy, OnInit } from '@angular/core';
import { iBisBaseComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { EditAppointmentService } from './edit-appointment.service';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';

@Component({
	selector: 'app-edit-appointment',
	templateUrl: './edit-appointment.component.html'
})
export class EditAppointmentComponent extends iBisBaseComponent implements OnInit, OnDestroy {

	public declare edit: EditAppointmentService;

	private modelChangeSub$: Subscription
	private onValueChangedSubject$: BehaviorSubject<string> = new BehaviorSubject(null)

	constructor(public proxy: ProxyService) {
		super(proxy.appointment, proxy.lg, proxy.iui, proxy.activatedRoute);

	}

	ngOnInit(): void {
		this.modelChangeSub$ = combineLatest([this.edit.modelChange, this.onValueChangedSubject$]).subscribe(_ => {
			if (this.edit.model.startDate && this.edit.model.userId) {
				this.edit.refreshAppointmentsByDateAndDoctor();
			}
		})
	}

	ngOnDestroy(): void {
		if (this.modelChangeSub$) {
			this.modelChangeSub$.unsubscribe()
		}
	}

	openPatient = () => {
		this.proxy.patient.showPopup(null).then((res: any) => {
			if (res) {
				this.proxy.patient.filter = false;
				this.proxy.patient.reloadData();
				this.proxy.appointment.model.patientId = res.id;
			}
		});
	}

	public customPatientDisplay = (row: any): string => {
		return row ? row.lastName + ' ' + row.firstName + (row.cnp ? (' - ' + row.cnp.substring(0, 7) + '...') : '') : null;
	}

	public displayPatientAppointment = (row: any): string => {
		if (row) {
			const startDate = new Date(row.startDate);
			const endDate = new Date(row.endDate);
			return this.edit.getHoursMinutes(startDate) + ' - ' + this.edit.getHoursMinutes(endDate) + ' ' + row.patientName;
		}
		return '';
	}

	onDateChanged = (event: any) => {
		if (event.event) {
			this.edit.model.startTime = null;
			this.edit.model.endTime = null;
			this.onValueChangedSubject$.next(event.value)
		}
	}

	onDoctorChanged = (event: any) => {
		if (event.event) {
			this.edit.model.startTime = null;
			this.edit.model.endTime = null;
			this.onValueChangedSubject$.next(event.value)
		}
		if (event && event.value) {
			this.edit.loadDoctorProcedures(event.value)
		}
	}

	onFileDelete = (e: any) => {

		if (e.event && e.previousValue.length > e.value.length) {
			const removedFiles = e.previousValue.filter((prev: any) => !e.value.some((curr: any) => curr.id === prev.id));
			//const addedFiles = e.value.filter((curr: any) => !e.previousValue.some((prev: any) => prev.id === curr.id));

			if (removedFiles.length) {
				removedFiles.forEach((file: any) => {
					if (this.edit.model.id) {
						this.edit.file.deleteFile(file.id).then(() => {
							this.edit.initFiles(this.edit.model.id);
						});
					}
				});
			}
		}
	}

	onProcedureChanged = (event: any) => {
		if (event.event) {
			// here fetch the duration from the selected procedure 
			const selectedProcedure = this.edit.doctorProcedures.find(proc => proc.id == event.value);
			this.edit.appointmentTimeInterval = selectedProcedure.duration || 40;
			this.onValueChangedSubject$.next(event.value)
			this.onStartTimeChanged({ value: this.edit.model.startTime })
		}
	}

	onStartTimeChanged = (ev: any) => {
		if (ev.value) {
			// Calculăm endTime (startTime + appointmentTimeInterval)
			const [startHour, startMinute] = ev.value.split(':').map(Number);
			const startTimeInMinutes = startHour * 60 + startMinute;
			const endTimeInMinutes = startTimeInMinutes + this.edit.appointmentTimeInterval;
			const endHour = Math.floor(endTimeInMinutes / 60);
			const endMinute = endTimeInMinutes % 60;
			const formattedEndTime = ('0' + endHour).slice(-2) + ':' + ('0' + endMinute).slice(-2);

			this.edit.model.endTime = formattedEndTime;

			this.edit.getEndTimes();
		}
	}

	// TODO: To disable the dates of the curent Clinic(party) which can be now in EditPartyWorkingSchedule
	// TODO: Check if we can move this functionality in that service (editParty or EditPartyWorkingSchedule)
	disabledDates = (e: any) => {
		if (e.view === 'month') {
			this.disabledDates = (data) => {
				return data.view === 'month' && new Date(data.date).getDay() == 0;
			};
		} else {
			this.disabledDates = undefined;
		}
	}

	disabledStartDates = (e: any) => {
		if (e.view === 'hour') {
			this.disabledStartDates = (data) => {
				return data.view === 'hour' && new Date(data.date).getHours() > 14;
			}
		}
	}

	onCustomItemCreating = (e: any) => {
		const customTime = e.text;
		e.customItem = { displayValue: customTime, value: customTime };
	}
}
